import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { find, isEmpty } from 'lodash';
import { Image } from '$components/basic/Image';

const LoaderDivStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => `url(${props.src}) no-repeat center`};
  max-width: 100%;
  height: 390px;
  max-height: 750px;
`;

const GmapDivStyled = styled.div`
  width: 100%;
  height: 390px;
  &.-hidden {
    display: none;
  }
`;

const UK = {
  name: 'UK',
  centerLatLng: {
    lat: 52.450355,
    lng: -1.592563,
  },
  zoom: 6.8,
};

function httpGetAsync(theUrl, callback) {
  const xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) callback(xmlHttp.responseText);
  };
  xmlHttp.open('GET', theUrl, true);
  xmlHttp.send(null);
}

let map = '';

export default class GoogleMap extends Component {
  state = {
    showLoader: true,
  };

  mapRef = createRef();

  componentDidMount() {
    const { apiKey } = this.props;
    if (window.google_map_script_tag) {
      // when multiple components are initialized at the same time
      const waitScriptLoad = setInterval(() => {
        if (window.google) {
          this.onScriptLoad();
          clearInterval(waitScriptLoad);
        }
      }, 300);
    } else if (!window.google) {
      window.google_map_script_tag = true;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://maps.google.com/maps/api/js?key=${apiKey}`;
      script.async = true;
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(script, x);
      script.addEventListener('load', () => {
        this.onScriptLoad();
      });
    }
  }

  onScriptLoad = () => {
    if (!process.browser) return;
    const { areas, location = UK, landingUrl } = this.props;
    this.setState({ showLoader: false });
    httpGetAsync(`${landingUrl}/envelope-coverage.json`, (res) => {
      const coverage = JSON.parse(res);
      const locationFound = find(areas, ({ name }) => name === location);
      if (locationFound) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: locationFound.name, region: 'uk' }, function (results, status) {
          if (status === 'OK') {
            map.fitBounds(results[0].geometry.viewport);
          } else {
            /* eslint-disable no-console */
            console.log(`Geocode was not successful for the following reason: ${status}`);
          }
        });
      }
      if (this.mapRef.current instanceof Element) {
        map = new window.google.maps.Map(this.mapRef.current, {
          center: location.centerLatLng,
          zoom: location.zoom,
          mapTypeId: 'roadmap',
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: location.zoomControl,
          zoomControlOptions: {
            position:
              location.zoomControlOptions === 'TOP_RIGHT' && window.google.maps.ControlPosition.TOP_RIGHT,
          },
        });
        map.data.setStyle(() => ({
          fillColor: '#58b0ff',
          fillOpacity: 0.4,
          strokeWeight: 1,
        }));
        if (!isEmpty(coverage)) map.data.addGeoJson(coverage);
      }
    });
  };

  render() {
    const { showLoader } = this.state;
    const { image, className } = this.props;
    return (
      <div className={classNames('GoogleMap', className)}>
        {showLoader && (
          <LoaderDivStyled src={image}>
            <Image
              className="title-image"
              provider="cloudinary"
              src="/icons/icon_spinner_ua5yua.svg"
              alt="spinner"
              layout="fill"
              fill="natural"
            />
          </LoaderDivStyled>
        )}
        <GmapDivStyled ref={this.mapRef} className={classNames('gmap', showLoader && '-hidden')} />
      </div>
    );
  }
}

GoogleMap.propTypes = {
  areas: PropTypes.array,
  location: PropTypes.any,
  image: PropTypes.string,
  apiKey: PropTypes.string,
  landingUrl: PropTypes.string,
  className: PropTypes.string,
};

GoogleMap.defaultProps = {
  areas: [],
  location: '',
  image: '',
  apiKey: '',
  landingUrl: '',
  className: '',
};
